import { render, staticRenderFns } from "./insureTypeIndex.vue?vue&type=template&id=49cf7403&scoped=true&"
import script from "./insureTypeIndex.vue?vue&type=script&lang=js&"
export * from "./insureTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf7403",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cf7403')) {
      api.createRecord('49cf7403', component.options)
    } else {
      api.reload('49cf7403', component.options)
    }
    module.hot.accept("./insureTypeIndex.vue?vue&type=template&id=49cf7403&scoped=true&", function () {
      api.rerender('49cf7403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/manage/insureTypeIndex.vue"
export default component.exports